declare global {
  interface Window {
    [key: string]: (() => void) | undefined;
  }
}

export const loadGoogleMapsLoader = async (
  apiKey: string | undefined,
): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!apiKey) {
      reject(new Error('Google Maps API key is missing.'));
      return;
    }

    const validateKey = (key: string): Promise<void> => {
      return new Promise((resolve, reject) => {
        const uniqueCallback = `gmaps_validate_${Date.now()}`;
        const timeout = setTimeout(() => {
          reject(new Error('Google Maps API validation timed out.'));
          cleanup();
        }, 1000);

        const script: HTMLScriptElement = document.createElement('script');

        const cleanup = () => {
          clearTimeout(timeout);
          delete window[uniqueCallback];
          if (script.parentNode) {
            document.head.removeChild(script);
          }
        };

        window[uniqueCallback] = () => {
          try {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: 'New York' }, (_, status) => {
              if (status === 'OK' || status === 'ZERO_RESULTS') {
                resolve();
              } else if (status === 'REQUEST_DENIED') {
                reject(
                  new Error('Invalid or unauthorized Google Maps API key.'),
                );
              } else {
                reject(new Error(`Google Maps API error. Status: ${status}`));
              }
              cleanup();
            });
          } catch {
            reject(new Error('Google Maps API failed to initialize locally.'));
            cleanup();
          }
        };

        script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=${uniqueCallback}&v=weekly&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onerror = () => {
          reject(
            new Error('Failed to load the Google Maps script for validation.'),
          );
          cleanup();
        };

        document.head.appendChild(script);
      });
    };

    validateKey(apiKey).then(resolve).catch(reject);
  });
};
